module.exports = __webpack_public_path__ + "img/card-bg-only-racer.71056a7f.jpg";